import { render, staticRenderFns } from "./CurrentApprovalList.vue?vue&type=template&id=c2b11bee"
import script from "./CurrentApprovalList.vue?vue&type=script&lang=js"
export * from "./CurrentApprovalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports